export default __webpack_public_path__ + "static/media/mouse-scroll.9f2e2630.svg";